const o=["CA","US"];export{o as ALLOWED_COUNTRIES};
//# sourceMappingURL=config.js.map
